export const STRIKE_SURFACES_QUERY_KEY = "strikeSurfaces";
export const SURFACES_QUERY_KEY = "surfaces";
export const SHORTCUTS_QUERY_KEY = "shortcuts";
export const BROKING_COMPANIES_QUERY_KEY = "brokingCompanies";
export const TEAM_RUN_COLORS_QUERY_KEY = "teamRunColors";
export const FILTERS_QUERY_KEY = "filters";
export const MARKET_ANALYSIS_FILTERS_QUERY_KEY = "marketAnalysisFilters";
export const VOL_SURFACE_FILTERS_QUERY_KEY = "volSurfaceFilters";
export const FUTURES_CURVE_PRODUCTS_QUERY_KEY = "futuresCurveProducts";
export const FUTURES_CURVE_CONTRACTS_QUERY_KEY = "futuresCurveContracts";
export const FUTURES_CURVE_CONTROL_TABLE_QUERY_KEY = "futuresCurveControlTable";